export interface RequestOtherFlightsInterface {
  countrySlug: string;
}

export interface Cities {
  cities: City[];
}

export interface City {
  slug: string;
  name: string;
}

export class ResponseOtherFlights {
  status: boolean;

  message: string;

  data: Cities;

  constructor(data: any) {
    this.status = data.status || false;
    this.message = data.message || "";
    this.data = data.data || null;
  }
}
